import { Container } from "@mui/material";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import Center from "layouts/wrapper/Center";
import { useEffect } from "react";

function MokStdRequest() {
    useEffect(() => {
        mokPopup();
        // 인증결과 콜백함수 정의
        const script = document.createElement('script');
        const callBackFunc = document.createTextNode(
            "function result(result) {" +
            "try {" +
            "result = JSON.parse(result);" +
            "document.querySelector('#result').value = JSON.stringify(result, null, 4);" +
            "} catch (error) {" +
            "document.querySelector('#result').value = result;" +
            "}" +
            "}");
        script.appendChild(callBackFunc);
        document.body.appendChild(script);

        // Cleanup 함수
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    // PC | 모바일 스크립트 인식 구분
    // PC 스크립트 사용시
    const mokPopup = () => {
        window.MOBILEOK.process("https://이용기관 본인인증-표준창 요청 (서버 (Node.js))URL/mok/mok_std_request", "WB", "result");
    };

    // 모바일 스크립트 사용시
    // const mokMove = () => {
    // window.MOBILEOK.process("https://이용기관 본인인증-표준창 요청 (서버 (Node.js))URL/mok/mok_std_request", "WB", "");
    // };
    return (
        <Container>
            <Container maxWidth={1200}>
                <Center>
                    <P size={50}>본인인증 요청</P>
                </Center>
            </Container>
        </Container>
    );
}

export default MokStdRequest;